import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class CouponService {

    constructor(private api: ApiService, private http: HttpClient) {
    }

    getCoupons(query?: any) {
        return this.api.get(this.api.path + '/coupon', query);
    }

    getCouponStats(query?: any, resellerId?: number) {
        if (resellerId) {
            return this.api.get(this.api.path + '/coupon/' + resellerId + '/stats', query);
        }
        return this.api.get(this.api.path + '/coupon/stats', query);
    }

    getCoupon(id: any) {
        return this.api.get(this.api.path + '/coupon/' + id);
    }

    cancelCoupon(id: any) {
        return this.api.get(this.api.path + '/coupon/' + id + '/cancel');
    }

    pendingCoupon(id: any) {
        return this.api.get(this.api.path + '/coupon/' + id + '/pending');
    }

    endingCoupon(id: any) {
        return this.api.get(this.api.path + '/coupon/' + id + '/ending');
    }

    getNotSettledOdds(query?: any) {
        return this.api.get(this.api.path + '/coupon/notSettledOdds', query);
    }

    getWaitingCouponMarkets(id: any) {
        return this.api.get(this.api.path + '/coupon/detail/' + id + '/waiting');
    }

    completePay(id: any, payoutPin?: string) {
        return this.api.post(this.api.path + '/coupon/' + id + '/completePay', { payoutPin: payoutPin });
    }

    betSettlement(params: { betResult: number; oddHash: string }) {
        return this.api.post(this.api.path + '/coupon/betSettlement', params);
    }
    
    getBiggestWin(){
        return this.api.get(this.api.path + '/coupon/biggestWin')
    }
    
    initiateRequest(betradarId: string) {
        return this.api.post(this.api.path + '/coupon/reinitialize', {match_id: betradarId});
    }
    
    updateRowStatus(couponId: number, rowId: number, newRowStatus: number) {
        const body = { couponId, rowId, newRowStatus };
        return this.api.post(this.api.path + '/coupon/rowStatus', body);
    }
    
    assignCategory(userId: number, category: string) {
        const body = { userId, category };
        return this.api.post(this.api.path + '/coupon/assignCategory', body);
    }
    
    getCategories() {
        return this.api.get(this.api.path + '/coupon/categories');
    }
    
    getUsersCountWithTags(resellerId?: number) {
        if (resellerId) {
            return this.api.get(this.api.path + '/coupon/' + resellerId + '/users/countWithTags');
        }
        return this.api.get(this.api.path + '/coupon/users/countWithTags');
    }

    updateTagStatus(adminName: string, userName: string, status: string) {
        const body = { adminName, userName, status };
        const basePath = this.api.path || 'admin';
        return this.api.post(basePath + '/coupon/updateTagStatus', body);
    }

    getTagLogs() {
        // Endpoint no longer accepts userName; fetch all tag logs without query params
        return this.api.get(this.api.path + '/coupon/getTagLogs');
    }
      
}
